export default {
  LOADING: 'loading',
  COMPLETE: 'complete',
  ERROR: 'error',
};


// WEBPACK FOOTER //
// ./modules/recipe/constants/RecipeListStatusConstants.js